import React from "react";
import { Link, useLocation } from "react-router-dom";

/**
 * Bottom-left fixed "MoodCard" brand pill — mirrors the platform-injected
 * "Made with Emergent" badge in the bottom-right. Same approximate size
 * and offset so the two read as a balanced pair on every screen.
 *
 * iter-85: hidden on card-detail and public-card routes. The card itself
 * IS the brand surface there (with its own "made with moodcard.app"
 * watermark inside the artwork), and the floating badge clutters the
 * mobile viewport. Stays visible on Home, Discover, Saved, etc.
 *
 * Click → home. Tiny tap target on mobile, full pill on desktop.
 */
export default function BrandBadge() {
    const location = useLocation();
    const path = location.pathname || "";
    // Hide on every route where a card is the dominant subject — public
    // share viewer, owner's CardDetail, dedicated Open view, Remix Studio,
    // and the dedicated /render & /render-export PNG-export iframes (which
    // must NEVER contain floating chrome anyway). Anything else keeps the
    // pill, so the brand is still visible on Home and listing pages.
    const hideOn = ["/c/", "/open/", "/card/", "/remix/", "/render", "/render-export", "/r/"];
    if (hideOn.some((p) => path.startsWith(p))) return null;

    return (
        <Link
            to="/"
            data-testid="moodcard-brand-badge"
            className="fixed bottom-3 left-3 sm:bottom-4 sm:left-4 z-30 group"
            aria-label="MoodCard home"
        >
            <span
                className="inline-flex items-center gap-2.5 px-5 py-3 rounded-full
                           bg-black text-white
                           border border-white/12
                           shadow-[0_8px_22px_rgba(0,0,0,0.45)]
                           hover:bg-neutral-900 transition-colors"
            >
                {/* Brand mark — bold emerald square WITH inner dot (iter-101). */}
                <span
                    aria-hidden="true"
                    className="inline-flex items-center justify-center"
                    style={{
                        width: "14px",
                        height: "14px",
                        border: "2px solid #34D399",
                        borderRadius: "2px",
                        boxShadow: "0 0 8px rgba(52, 211, 153, 0.55)",
                    }}
                >
                    <span style={{
                        width: "4px",
                        height: "4px",
                        borderRadius: "1px",
                        background: "#34D399",
                        boxShadow: "0 0 4px rgba(52, 211, 153, 0.8)",
                    }} />
                </span>
                <span
                    className="font-sans uppercase font-bold leading-none"
                    style={{
                        fontSize: "15px",
                        letterSpacing: "0.18em",
                        color: "#FFFFFF",
                    }}
                >
                    MoodCard
                </span>
            </span>
        </Link>
    );
}
